import { Editor } from '../lib';

export function StandaloneEditor() {
  return <Editor />;
}
